class VariantDescriptionBlock extends HTMLElement {
  connectedCallback() {
    this.fallback = this.dataset.fallback || '';
    this.defaultContent = this.innerHTML;

    // Find the variant picker form on this product
    this.variantPicker = document.querySelector('variant-selects, variant-radios');

    if (this.variantPicker) {
      this.variantPicker.addEventListener('change', this.handleChange.bind(this));
    }

    // Also catch Dawn's custom event as a backup
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  disconnectedCallback() {
    if (this.variantPicker) {
      this.variantPicker.removeEventListener('change', this.handleChange.bind(this));
    }
    document.removeEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  handleChange() {
    // Use setTimeout to wait for Dawn to update the hidden input
    setTimeout(() => {
        const variantIdInput = document.querySelector('input[name="id"]');
        if (!variantIdInput) return;
        this.updateDescription(variantIdInput.value);
    }, 0);
    }

  handleVariantChange(event) {
    const variantId = event.detail?.variant?.id;
    if (variantId) this.updateDescription(variantId);
  }

  updateDescription(variantId) {
    const desc = window.variantDescriptions?.[String(variantId)];

    if (desc) {
      this.innerHTML = desc;
    } else if (this.fallback) {
      this.innerHTML = this.fallback;
    } else {
      this.innerHTML = this.defaultContent;
    }
  }
}

customElements.define('variant-description-block', VariantDescriptionBlock);